<script>
import WarningIcon from "@/assets/icons/WarningIcon.svg"

export default {
  name: "FailedToFetchModal",
  props: {
    value: {
      Boolean, default() {
        return false
      }
    },
    modelId: {
      String, default() {
        return null
      }
    },
    displayName: {
      String, default() {
        return null
      }
    },
    name: {
      String, default() {
        return null
      }
    },
  },
  data() {
    return {
      WarningIcon,
    }
  },
  computed: {
    modalTitleMessage() {
      return this.lodash.startCase(this.$t(`failed_to_fetch_{name}`, {name: this.name}))
    },
    modalDescriptionHTML() {
      const identifier = this.displayName || this.modelId
      return `${this.$t(`failed_to_fetch_{name}`, {name: this.name})} <span style="font-weight: 700; color: #667085;">[ID ${this.lodash.escape(identifier)}]</span>. ${this.$t('Please try again or contact support')}.`
    }
  },
  methods: {
    onBackButtonClick() {
      return this.$emit("back")
    },
    onRetryButtonClick() {
      return this.$emit("retry")
    }
  }
}
</script>

<template>
  <b-modal
      v-model="value"
      centered
      hide-header
      hide-footer
      size="md"
      no-close-on-backdrop
  >
    <div class="text-center mb-4">
      <img class="mb-2" :src="WarningIcon" alt="Warning Icon"/>
      <h3>{{ modalTitleMessage }}</h3>
      <p class="text-muted" v-html="modalDescriptionHTML"></p>
    </div>
    <div class="d-flex mt-3">
      <b-button variant="light" block class="me-3" @click="onBackButtonClick">{{ $t('Back') }}</b-button>
      <b-button variant="primary" block class="m-0" @click="onRetryButtonClick">{{ $t('Retry') }}</b-button>
    </div>
  </b-modal>
</template>

<style scoped lang="scss">
p {
  font-size: 14px;
  line-height: 24px;
}

button {
  font: 600 12px/16px Lato, sans-serif;
}
</style>
